import { GROUP_ALLOW_APPLY_TYPE, GROUP_PERMISSION } from './group';

// 团队允许加入的类型
export const TEAM_ALLOW_APPLY_TYPE = {
  ...GROUP_ALLOW_APPLY_TYPE,
};
// 团队权限
export const TEAM_PERMISSION = {
  ...GROUP_PERMISSION,
  AUTO_BECOME_PROJECT_ADMIN: 1010,
  CREATE_TERM_BANK: 1020,
  ACCESS_TERM_BANK: 1030,
  CHANGE_TERM_BANK: 1040,
  DELETE_TERM_BANK: 1050,
  CREATE_TERM: 1060,
  CHANGE_TERM: 1070,
  DELETE_TERM: 1080,
  CREATE_PROJECT: 1090,
  CREATE_PROJECT_SET: 1100,
  CHANGE_PROJECT_SET: 1110,
  DELETE_PROJECT_SET: 1120,
  USE_OCR_QUOTA: 1130,
  USE_MT_QUOTA: 1140,
  INSIGHT: 1150,
};
